import React, { Component } from "react";
import { Accordion } from "./components/setting-accordion";
import { SaveButton } from "./components/save-button";
import Icon from "../../../../../../images/settings-icons/setting-carbs-fat.png";
import styled from "styled-components";
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { Circle } from 'rc-progress';
import { modifyUser } from "../../../../../../api";

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const CircleContainer = styled.div`
  width: 220px;
  padding: 24px;
  position: relative;

  @media(max-width: 1170px) {
    width: 140px;
    padding: 12px;
  }
  @media(max-width: 500px) {
    width: 110px;
    padding: 4px;
  }
  @media(max-width: 410px) {
    width: 80px;
    padding: 0px 3px;
  }
`;

const CircleText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-55%);
  p {
    margin: 0;
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    text-transform: uppercase;
    @media(max-width: 500px) {
      font-size: .7rem;
    }
  }

  p:nth-child(2) {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2rem;
    @media(max-width: 500px) {
      font-size: 1.25rem;
      line-height: 1.25rem;
    }
  }
`;

const FatCarbSlider = withStyles({
  root: {
    color: '#06cb40',
    height: 8,
  },
  thumb: {
    height: 36,
    width: 36,
    backgroundColor: '#dae3f1',
    border: '6px solid currentColor',
    marginTop: -13,
    marginLeft: -13,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    color: '#b7c1d6',
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const minFatPermyriad = 2000;
const maxFatPermyriad = 4000;

function calcMacros({newFatPermyriad, initProtein, initFat, initCarbs}) {
  const initCalories = initProtein * 4 + initFat * 9 + initCarbs * 4;
  const proteinPerc = (initProtein * 4) / initCalories; // protein is constant;
  const sliderFatG = Math.round(((newFatPermyriad / 10000) * initCalories) / 9);
  const sliderCarbsG = Math.round(
    ((1 - newFatPermyriad / 10000 - proteinPerc) * initCalories) / 4,
  );
  const sliderProteinG = Math.round(initProtein);
  const maxCalories = sliderProteinG * 4 + sliderFatG * 9 + sliderCarbsG * 4;
  return {
    protein: sliderProteinG,
    fat: sliderFatG,
    carbs: sliderCarbsG,
    maxCalories,
  };
}

const CircleGraph = (props) => {
  let percent
  if (props.text === "Fat") {
    percent = (props.macro * 9)/props.maxCalories * 100
  } else {
    percent = (props.macro * 4)/props.maxCalories * 100
  }

  return (
    <CircleContainer>
      <Circle
        percent={percent}
        strokeWidth="5"
        strokeLinecap="round"
        strokeColor="#e8902a"
        trailWidth="5"
        trailColor="#cbcddc"
      />
      <CircleText>
        <p>{props.text}</p>
        <p>{props.macro}</p>
      </CircleText>
    </CircleContainer>
  )
}

class FatCarbAdjustment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sliderValue: null,
      expanded: false,
      isSubmitting: false,
      show: false,
    };
  }

  fatPermyriadToName = (fatPermyriad) => {
    if (fatPermyriad < 2500) {
      return 'High carbs';
    } else if (fatPermyriad < 3000) {
      return 'Medium carbs';
    } else if (fatPermyriad < 3500) {
      return 'Balanced';
    } else if (fatPermyriad < 4000) {
      return 'Medium fat';
    } else {
      return 'High fat';
    }
  }

  handleSlider = (e, val) => {
    this.setState({sliderValue: val})
  }

  handleSubmit = () => {
    const effectiveFatPermyriad = this.state.sliderValue === null ? this.props.fat_permyriad : this.state.sliderValue;
    this.setState({ isSubmitting: true });

    modifyUser(this.props.userId, this.props.portalId, {
        fat_permyriad: effectiveFatPermyriad,
      }).then((res) => { 
        setTimeout(() => {
          this.setState({ isSubmitting: false });
          this.props.openSnackbar('Setting has been updated', false)
          this.props.loadPortalAccount();
        }, 1000);
        console.log('successful update')
      }).catch((err) => {
        setTimeout(() => {
          this.setState({ isSubmitting: false });
          this.props.openSnackbar('Setting failed to update', true)
        }, 1000);
        console.log('failed update: ', err)
      });

    // this.props
    //   .modifyUser(this.props.userId, {
    //     fat_permyriad: effectiveFatPermyriad,
    //   })
    //   .then(() => {
    //     this.setState({
    //       expanded: false,
    //       isSubmitting: false,
    //       show: false,
    //     });
    //     this.props.openFeedback(
    //       "Carbs and fat setting updated successfully",
    //       false
    //     );
    //   })
    //   .catch((err) => {
    //     this.setState({
    //       expanded: false,
    //       isSubmitting: false,
    //     });
    //     this.props.openFeedback("Unable to update Carbs and Fat setting", true);
    //   });
  };

  renderCurrent = (setting) => {
    if (window.innerWidth >= 450) {
      const labels = [
        "HIGH CARBS",
        "MEDIUM CARBS",
        "BALANCED",
        "MEDIUM FAT",
        "HIGH FAT",
      ];
      return labels[setting];
    } else {
      const labels = [
        "HIGH CARBS",
        "MED CARBS",
        "BALANCED",
        "MED FAT",
        "HIGH FAT",
      ];
      return labels[setting];
    }
  };

  render() {
    const effectiveFatPermyriad = this.state.sliderValue === null ? this.props.fat_permyriad : this.state.sliderValue;
    const submitDisabled = (effectiveFatPermyriad === this.props.fat_permyriad);
    const showRestriction = (this.props.highestFatPermyriad < maxFatPermyriad && effectiveFatPermyriad >= this.props.highestFatPermyriad)
    const previewInput = {
      newFatPermyriad: effectiveFatPermyriad,
      initProtein: this.props.protein,
      initFat: this.props.fat,
      initCarbs: this.props.carbs
    };

    const previewResult = calcMacros(previewInput);
    return (
      <Accordion
        show={this.state.show}
        setShow={(val) => this.setState({show: val})}  
        icon={Icon}
        settingName="Carb & fat preference"
        currentSetting={this.fatPermyriadToName(this.props.fat_permyriad)}
        description="Adjust carb and fat targets"
        alternateColor
      >
        <>
          <div style={{display: 'flex', justifyContent: 'center', marginTop: '32px'}}>
            <CircleGraph text="Protein" maxCalories={previewResult.maxCalories} macro={previewResult.protein} />
            <CircleGraph text="Carbs" maxCalories={previewResult.maxCalories} macro={previewResult.carbs} />
            <CircleGraph text="Fat" maxCalories={previewResult.maxCalories} macro={previewResult.fat} />
          </div>
          <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop: '32px'}}>
            <p id="preferences-slider-min">MORE CARBS</p>
            <p id="preferences-slider-max">MORE FAT</p>
          </div>
          <FatCarbSlider 
            min={minFatPermyriad}
            max={this.props.highestFatPermyriad}
            step={1}
            value={effectiveFatPermyriad}
            onChange={this.handleSlider}
            name="sliderValue"
            valueLabelDisplay='off'
            aria-label='fatcarb-slider'
          />
          <div style={{height: '32px'}}></div>
          {showRestriction && (
            <p style={{ marginBottom: "10px", fontWeight: "bold" }}>
              Your carbs to fat ratio is currently restricted to keep your carbs
              from getting too low.
            </p>
          )}
          <ButtonRow>
            <SaveButton
              disabled={submitDisabled}
              isLoading={this.state.isSubmitting}
              onClick={this.handleSubmit}
            />
          </ButtonRow>
        </>
      </Accordion>
    );
  }
}

// function mapStateToProps(state) {
  // const protein = Number(state.user.macroData.baseProtein)
  // const carbs = Number(state.user.macroData.baseCarbs)
  // const fat = Number(state.user.macroData.baseFat)
  // let highestFatPermyriad = maxFatPermyriad
  // if ('highest_fat_permyriad' in state.user) {
  //   highestFatPermyriad = state.user.highest_fat_permyriad
  // }
  // return {
  //   userId: state.user.id,
  //   protein: protein,
  //   carbs: carbs,
  //   fat: fat,
  //   highestFatPermyriad: highestFatPermyriad,
  //   fat_permyriad: state.user.fat_permyriad,
  // }
// }

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ modifyUser, openFeedback }, dispatch);
// }

// export default connect(mapStateToProps, mapDispatchToProps)(FatCarbAdjustment);

export default FatCarbAdjustment;
